import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import aioaIconType30 from "../../Assets/img/widget-icon/aioa-hide-icon-type-30.svg";
import aioaIconType31 from "../../Assets/img/widget-icon/aioa-hide-icon-type-31.svg";
import aioaIconType32 from "../../Assets/img/widget-icon/aioa-hide-icon-type-32.svg";
import aioaIconType33 from "../../Assets/img/widget-icon/aioa-hide-icon-type-33.svg";
import aioaIconType34 from "../../Assets/img/widget-icon/aioa-hide-icon-type-34.svg";

import useWindowSize from "../../Helpers/useWindowSize";

// widget icon array
const widgetIconJson = [
    {
        id: 30,
        iconImage: aioaIconType30,
    },
    {
        id: 31,
        iconImage: aioaIconType31,
    },
    {
        id: 32,
        iconImage: aioaIconType32,
    },
    {
        id: 33,
        iconImage: aioaIconType33,
    },
    {
        id: 34,
        iconImage: aioaIconType34,
    },
];

interface PropTypes {
    setChangeHideWidgetIconType: Function,
    changeHideWidgetIconType: any
}

// component to render widget icon type
const WidgetHideIconType = (props: PropTypes) => {

    // PropTypes
    const { setChangeHideWidgetIconType, changeHideWidgetIconType } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();
    const windowWidth = useWindowSize();

    // State
    const [widgetHideIconType, setWidgetHideIconType] = useState<number>(34);

    // Set current widget icon type
    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if widget icon type is defined
            if (currentWebsite.widget_hide_icon_type) {
                setWidgetHideIconType(currentWebsite.widget_hide_icon_type);
            } else {
                setWidgetHideIconType(34);
            }
        }
    }, [currentWebsite])

    // set current icon value in prop function
    useEffect(() => {
        // check if widget icon type is available
        if (widgetHideIconType) {
            setChangeHideWidgetIconType(widgetHideIconType);
        }
    }, [widgetHideIconType])
    console.log("widgetHide", widgetHideIconType, currentWebsite?.widget_hide_icon_type);
    return (
        <>
            <fieldset className="aioa_dashboard-widget-settings-fieldset">
                <legend className="visually-hidden">{t("Select Widget Icon Type")}</legend>
                <Row xs={2} sm={3} md={4} lg={5} xl={4} xxl={3} className={`g-4 ${(windowWidth.windowSize > 1800) ? `row-cols-xxxl-5` : `row-cols-xxxl-4`}`}>
                    {widgetIconJson.map((iconType, index) => {
                        return (
                            <Col key={iconType.id}>
                                <div className={`aioa_dashboard-widget-setting-icon-box ${iconType.id === 13 ? `flat-logo` : ``} ${(iconType.id === widgetHideIconType) ? 'active' : ''}`}>

                                    <Form.Check type="radio" id={`icon_type_${iconType.id}`} aria-label={t(`Icon type`, { widgetIconType: iconType.id }).toString()}>

                                        <Form.Check.Input type="radio" name="widget_icon_type" id="widget_icon_type" checked={iconType.id === widgetHideIconType} className="" onChange={() => setWidgetHideIconType(iconType.id)} />

                                        <Form.Check.Label>
                                            <span className="visually-hidden">
                                                {t(`Icon type ${iconType.id}`).toString()}
                                                {/* {t(`Icon type`, { widgetHideIconType: iconType.id }).toString()} */}
                                            </span>

                                            <div className={`aioa_dashboard-widget-icon-box aioaIconType${iconType.id}`}></div>

                                            <div className="aioa_dashboard-widget-setting-icon-active-icon">
                                                <i className="material-symbols-outlined" aria-hidden="true">done</i>
                                            </div>
                                        </Form.Check.Label>

                                    </Form.Check>
                                </div>
                            </Col>
                        )
                    })}
                </Row>
            </fieldset>
        </>
    )
}

export default WidgetHideIconType;